/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '../core/request';

export class SecurityService {

    /**
     * @returns void
     * @throws ApiError
     */
    public static async logout(): Promise<void> {
        const result = await __request({
            method: 'GET',
            path: `/security/logout`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns boolean Ok
     * @throws ApiError
     */
    public static async checkCabinetAccess(): Promise<boolean> {
        const result = await __request({
            method: 'GET',
            path: `/security/check/cabinet/access`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

}